import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

import { TranslationService } from 'src/app/core/services/translation.service';

interface LangOption {
  label: string;
  value: 'en' | 'fr' | 'ar';
  flagImage?: string;
}

@Component({
  selector: 'io-language-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule],
  template: `
    <div class="lang-container">
      <p-select
        [ngModel]="current()"
        optionLabel="label"
        optionValue="value"
        [options]="languages"
        [style]="{ width: '100%' }"
        (ngModelChange)="onChange($event)"
      >
        <!-- Template custom option -->
        <ng-template let-lang pTemplate="item">
          <div class="flex items-center gap-2">
            <img [src]="lang.flagImage" alt="" class="w-5 h-3.5 rounded-xs object-cover border border-gray-200" />
            <span>{{ lang.label }}</span>
          </div>
        </ng-template>

        <!-- Selected -->
        <ng-template let-lang pTemplate="selectedItem">
          <div class="flex items-center gap-2">
            <img [src]="lang.flagImage" alt="" class="w-5 h-3.5 rounded-xs object-cover border border-gray-200" />
            <span>{{ lang.label }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  `,
  styles: [
    `
      .lang-container {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IoLanguageSwitcherComponent {
  private readonly i18n = inject(TranslationService);

  readonly current = computed(() => this.i18n.currentLanguage() ?? 'en');

  languages: LangOption[] = [
    { label: 'English', value: 'en', flagImage: 'assets/flags/gb.svg' },
    { label: 'Français', value: 'fr', flagImage: 'assets/flags/fr.svg' },
    { label: 'العربية', value: 'ar', flagImage: 'assets/flags/tn.svg' },
  ];

  onChange(lang: 'en' | 'fr' | 'ar') {
    this.i18n.setLanguage(lang);
  }
}
